import { BaseService } from '@myhealth-raccoon/services';
import { AppointmentType, FirstAvailableModel, AutomedDoctorDateModel, SiteBookingAvailabilityModel, AutomedDoctorAvailablilityModel, ServiceTypeSearchEnum } from './types';
import moment from 'moment';

class AvailabilityService extends BaseService {
    constructor() {
        super('v1/site', import.meta.env.VITE_BP_API_URL);
    }

    public async GetAppointmentTypes(siteId: number | string, serviceType?: ServiceTypeSearchEnum) {
        const query = new URLSearchParams(serviceType ? {
            serviceType: serviceType.toString()
        } : {});
        return this.get<AppointmentType[]>(`${siteId}/availability/appointmentTypes?${query}`)
    }

    public async GetFirstAvailable(
        siteId: string | number,
        appointmentTypeId: string,
        doctorId: string | number | null | undefined) {
            if(!appointmentTypeId) {
                return []
            }
            const query = new URLSearchParams({
                appointmentTypeId,
            });

            return this.get<FirstAvailableModel[]>(`${siteId}/availability/firstAvailable/${doctorId ? `user/${doctorId}` : 'all'}?${query}`);
        }

    public async GetBookingTimeslot(
        siteId: string | number,
        appointmentTypeId: string,
        doctorId: string | number | null | undefined,
        {
            startDate, endDate
        }: {
            startDate: Date, endDate: Date
        }
    ) {
        if(!appointmentTypeId) {
            return []
        }
        const query = new URLSearchParams({
            appointmentTypeId,
            startDate: moment(startDate).format('YYYY-MM-DD'),
            endDate: moment(endDate).format('YYYY-MM-DD'),
        });
        return this.get<SiteBookingAvailabilityModel[] | AutomedDoctorAvailablilityModel>(`${siteId}/availability/${doctorId ? `user/${doctorId}` : 'all'}?${query}`);   
    }

    /** @deprecated Not sure if this works */
    public async GetDoctorDatesAndFirstAvailable(siteId: number, year: number, month: number, userId: number | string | undefined) {
        const query = new URLSearchParams({
            year: year.toString(), month: month.toString(), userId: userId?.toString() ?? ""
        });
        return this.get<AutomedDoctorDateModel>(`${siteId}/availability/datesAndFirstAvailable?${query}`);
    }
}

export const availabilityService = new AvailabilityService();
export * from './types';